import React from 'react';

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    title?: string;
    containerClassName?: string;
}

export default function Textarea({ title, containerClassName = '', className = '', ...props }: TextareaProps) {
    return (
        <div className={containerClassName}>
            {title && (
                <label htmlFor={props.id} className="block mb-1 text-secondary font-semibold">
                    {title}
                    {props.required && <span className="text-red-500 ml-0.5">*</span>}
                </label>
            )}
            <textarea
                className={`w-full px-4 py-3 border border-[#D2D2D2] rounded-lg focus:ring-2 focus:ring-[#151515] focus:border-[#151515] outline-none transition-colors bg-gray-50 focus:bg-white placeholder-[#52525B] resize-none text-[14px] ${className}`}
                {...props}
            />
        </div>
    );
}
